import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {BasicApiResponseModel, ApiVisa } from '..';
import { Observable } from 'rxjs';

interface TokenReq {
  appletCode: string;
  tenantCode: string;
}

interface TokenRes {
  appletCode: string;
  tenantCode: string;
  token: string;
}


@Injectable({
  providedIn: 'root'
})
export class IdentityTokenService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/token';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/token';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'identity/token';
    this.httpClient = http;
  }

  getRefreshToken(
    dtoObject: TokenReq[], 
    visa: ApiVisa
  ) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/refresh';
    return this.httpClient.post<BasicApiResponseModel<TokenRes[]>>
      (Url, dtoObject, this.getHttpHeader(visa))
  }

  getSingleRefreshToken(
    dtoObject: TokenReq, 
    visa: ApiVisa
  ) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const Url = this.apiUrl + '/refresh/singleToken';
    return this.httpClient.post<BasicApiResponseModel<TokenRes>>
      (Url, dtoObject, this.getHttpHeader(visa))
  }

}
